module.exports = __webpack_public_path__ + "static/media/grifos-200x200.93e345a7.png";